@if (!isHidden) {
  <div
    class="field">
    <label class="upper">{{ displayName }}</label>
    <div class="is-readonly">{{ value }}</div>
  </div>
}
